// Basic
import { useState } from 'react';
// Store & actions
import useSessionStore from '@/app/store/session';
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsOrganizations from '../../api/actionsOrganizations';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import ModalAddAlertsEmail from '../modals/alerts/ModalAddAlertsEmail';
import ModalConfigureAlerts from '../modals/alerts/ModalConfigureAlerts';
import NewPosConnectionsSection from '../alerts/NewPosConnectionsSection';
import SimCardsConsumptionSection from '../alerts/SimCardsConsumptionSection';
import PageActions from '@/common-utils/components/renders/pageActions/PageActions';
import { Separator } from '@/common-utils/components/ui/separator';
// Common
import ICONS from '@/common-utils/enums/icons';
import AlertEmailTypes from '../../enums/AlertEmailTypes';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
import Permissions from '@/app/permissions/Permissions';
// Lang
import { nsOrganization } from '@/app/i18n/namespaces';

/**
 *@returns {JSX} AlertsPanel
 */
function AlertsPanel() {

    // Store
    const permissions = useSessionStore(s => s.session.permissions);
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    // State
    const [showModalAddAlertsEmail, setShowModalAddAlertsEmail] = useState(false);
    const [showModalConfigureAlerts, setShowModalConfigureAlerts] = useState(false);
    const [emailType, setEmailType] = useState();

    // Api calls
    const { isFetching: isFetchingAlertReceivers } = actionsOrganizations.getAlertReceivers(rootOrganization.uuid, false);
    const { isFetching: isFetchingSimAlerts } = actionsOrganizations.getSimAlerts(rootOrganization.uuid, false);

    // Functions
    const handleShowModalAddEmail = (type) => {
        setShowModalAddAlertsEmail(true);
        setEmailType(type);
    };

    return (
        <div>
            <div className='space-y-4'>
                <div>
                    <Entity
                        entity={'details.alerts.new_pos_connections.title'}
                        namespace={nsOrganization}
                        className='text-lg font-medium'
                    />
                </div>
                <PageActions
                    actions={
                        [
                            {
                                icon: ICONS.ADD,
                                entity: 'details.alerts.add_emails',
                                namespace: nsOrganization,
                                visible: true,
                                onClick: () => handleShowModalAddEmail(AlertEmailTypes.NEW_POS_EMAILS.name),
                                disabled: !hasRequiredPermissions({
                                    permissions: permissions,
                                    requiredPermissions: [
                                        Permissions.ORGANIZATION_UPDATE_ALERT_POS.name
                                    ]
                                }) || isFetchingAlertReceivers,
                                tooltipForbidden: 'title.permissions.access_denied'
                            }
                        ]
                    }
                />
                <NewPosConnectionsSection />
            </div>
            <Separator className='my-4' />
            <div>
                <div className='space-y-4'>
                    <div>
                        <Entity
                            entity={'details.alerts.consumption.title'}
                            namespace={nsOrganization}
                            className='text-lg font-medium'
                        />
                    </div>
                    <PageActions
                        actions={
                            [
                                {
                                    icon: ICONS.ADD,
                                    entity: 'details.alerts.add_emails',
                                    namespace: nsOrganization,
                                    visible: true,
                                    onClick: () => handleShowModalAddEmail(AlertEmailTypes.SIM_EMAILS.name),
                                    disabled: !hasRequiredPermissions({
                                        permissions: permissions,
                                        requiredPermissions: [
                                            Permissions.ORGANIZATION_UPDATE_ALERT_SIMS.name
                                        ]
                                    }) || isFetchingSimAlerts,
                                    tooltipForbidden: 'title.permissions.access_denied'

                                },
                                {
                                    icon: ICONS.ALERTS,
                                    entity: 'details.alerts.configure_alerts',
                                    namespace: nsOrganization,
                                    onClick: () => setShowModalConfigureAlerts(true),
                                    visible: true,
                                    disabled: !hasRequiredPermissions({
                                        permissions: permissions,
                                        requiredPermissions: [
                                            Permissions.ORGANIZATION_UPDATE_ALERT_SIMS.name
                                        ]
                                    }) || isFetchingSimAlerts,
                                    tooltipForbidden: 'title.permissions.access_denied'
                                }
                            ]
                        }
                        retractable
                    />
                    <SimCardsConsumptionSection />
                </div>
                {showModalAddAlertsEmail &&
                    <ModalAddAlertsEmail
                        isOpen={showModalAddAlertsEmail}
                        setIsOpen={setShowModalAddAlertsEmail}
                        type={emailType}
                    />
                }
                {showModalConfigureAlerts &&
                    <ModalConfigureAlerts
                        isOpen={showModalConfigureAlerts}
                        setIsOpen={setShowModalConfigureAlerts}
                    />
                }
            </div>
        </div >
    );
}

export default AlertsPanel;